// 主表查询时间延迟(毫秒)
export const DB_MASTER_DELAY = 10*1000;

export const HOME_PREFIX = '/khfw-home-api';

export const HOME_PREFIX_AUTH = "/khfw-auth-api";

export const logout = `/logout.do`; // 退出登录